module.exports = __webpack_public_path__ + "static/media/errorClose.4a2c6265.svg";